import { brandColors } from 'types/colors';

export const bottomBox = {
  paddingX: '1rem',
  borderRadius: '.5rem',
  backgroundColor: '#fff',
  width: '32.5%',
  display: 'flex',
  // flexDirection: 'column',
  alignItems: 'start',
  height: '12rem',
  // justifyContent: 'space-between',
  flexWrap: 'wrap',
  overflowY: 'auto',
  overflowX: 'hidden',
  alignContent: 'flex-start',
  boxShadow:
    '0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.1),0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.06)',
};

export const BoxTitle = {
  fontWeight: 'bold',
  color: brandColors.BLUE,
  minWidth: 'fit-content',
  padding: '0.4rem',
  position: 'absolute',
  textShadow:
    'rgb(255, 255, 255) 2px 0px 0px, rgb(255, 255, 255) 1.75517px 0.958851px 0px, rgb(255, 255, 255) 1.0806px 1.68294px 0px, rgb(255, 255, 255) 0.141474px 1.99499px 0px, rgb(255, 255, 255) -0.832294px 1.81859px 0px, rgb(255, 255, 255) -1.60229px 1.19694px 0px, rgb(255, 255, 255) -1.97998px 0.28224px 0px, rgb(255, 255, 255) -1.87291px -0.701566px 0px, rgb(255, 255, 255) -1.30729px -1.5136px 0px, rgb(255, 255, 255) -0.421592px -1.95506px 0px, rgb(255, 255, 255) 0.567324px -1.91785px 0px, rgb(255, 255, 255) 1.41734px -1.41108px 0px, rgb(255, 255, 255) 1.92034px -0.558831px 0px;',

  // backdropFilter: 'blur(20px) saturate(180%)',
  // WebkitBackdropFilter: 'blur(20px) saturate(180%)',
  // optional subtle inner shadow for extra depth
  // boxShadow: 'inset 0 0 0.5px rgba(255,255,255,0.4)',
  // borderRadius: '0.5rem',
  //  ,
};

export const titleStyle = {
  backgroundColor: brandColors.GREY_LIGHT,
  padding: '.4rem',
  borderRadius: '.4rem',
  height: '2.3rem',
  paddingX: '.7rem',
  fontSize: '.9rem',
  alignItems: 'start',
  display: 'flex',
  color: '#000',
  alignItems: 'center',
  width: '100%',
};

export const waterStyle = {
  // backgroundColor: brandColors.BLUE_LIGHT,
  padding: '.4rem',
  borderRadius: '.4rem',
  width: '8rem',
  height: '2.3rem',
  // paddingLeft: '1.3rem',
  fontSize: '.9rem',
  // marginBottom: '.5rem',
  alignItems: 'start',
  // justifyContent: 'center',
  display: 'flex',
  color: '#000',
  // fontWeight: '300',
};

export const modeValueStyle = {
  backgroundColor: brandColors.GREY_LIGHT,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '2.3rem',
  height: '2.3rem',
  flex: '0 0 2.3rem',
  boxSizing: 'border-box',
  borderRadius: '.5rem',
  // marginLeft: '.5rem',
  border: `solid 1px ${brandColors.GREY}`,
};
